module.exports = __webpack_public_path__ + "images/integration/addons/scene7/scene7-images-example.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/integration/addons/scene7/scene7-images-example.png
// module id = 3062
// module chunks = 0